"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var helpers_1 = require("../utils/helpers");
var primary = '#3031d1';
var theme = {
    colors: {
        primary: primary,
        primaryInverted: (0, helpers_1.invertColor)(primary, true),
        primaryDarken: '#1314a7',
        error: '#AC0B0B',
        warning: '#f1c40f',
        info: '#3498db',
        success: '#2ecc71',
        gray: '#c3c3c3',
        lightGray: '#f5f5f5',
        mediumGray: '#eaeaea',
        borderColor: '#efefef',
        text: '#000000',
        inputBorderColor: '#dbdbdb',
        topBarBg: '#000000',
        pageBg: '#FFFFFF',
    },
    misc: {
        buttonBorderRadius: '0',
        inputBorderRadius: '0',
    },
    spacing: {
        none: '0',
        xxsmall: '0.25rem',
        xsmall: '0.5rem',
        small: '0.75rem',
        medium: '1rem',
        large: '1.25rem',
        xlarge: '1.5rem',
        xxlarge: '1.75rem',
    },
    columns: 12,
    breakpoints: {
        xs: 'min-width: 0px',
        sm: 'min-width: 600px',
        md: 'min-width: 960px',
        lg: 'min-width: 1280px',
    },
};
exports.default = theme;
